import { isEmpty } from 'lodash';
import { armsErrorSend } from '../libs/armsErrorSend';
import { intervalPromise } from '..';

/**
 * 在sdk加载之前存储埋点方法和数据的队列实例
 * 默认在userActive 之后调用一次，并且轮询三次，
 * 若有其他时机需要调用请直接执行consume，并确保在执行前已经加载sdk（appMobx.CookieConsentInstance.handleLoadSnippets(true)）。
 * - result页面接口请求后执行一次
 */
class _TrackerQueue {
  constructor() {
    if (typeof window === 'undefined') return;

    window.addEventListener('InstaUserActive', () => {
      this.intervalComsume();
    });
  }

  /**
   * 轮询消费队列
   * 之前只放在constructor发现如下问题：初始化时队列为空，轮询结束，后面push事件后，却没有成功执行，因此新增放在push中。
   */
  intervalExcuting = false;
  intervalComsume = () => {
    if (this.intervalExcuting) return;
    this.intervalExcuting = true;
    intervalPromise(
      () => {
        this.consume();
        return this.isQueueEmpty();
      },
      600,
      25
    ).finally(() => {
      this.intervalExcuting = false;
    });
  };

  /**
   * 队列列表
   *  结构：[]{name:'tiktok',trackFunction:this.trackTiktok,events:[payload1,payload2...]}
   */
  queue = [];

  /**
   * 自定义埋点队列，手动消费，自行维护数据结构。
   */
  customQueue = [];

  /**
   * 判断队列列表是否为空
   */
  isQueueEmpty = () => {
    if (isEmpty(this.queue)) return true;
    if (this.queue.every((item) => isEmpty(item.events))) return true;
    return false;
  };

  /**
   * 向埋点存储队列里增加数据。
   * @param trackName 要发送去的第三方平台名称
   * @param trackFunction 运行方法
   * @param {Array} eventPayload 方法payload，必须是数组
   * @param {Object} _this 函数的运行环境，默认this指向window。
   */
  push = (trackName, trackFunction, eventPayload = []) => {
    if (typeof window === 'undefined') return;

    if (!Array.isArray(eventPayload)) {
      armsErrorSend('pushTrackerQueue 参数错误', { filename: 'pushTrackerQueue', data: { trackName, eventPayload } });
    }
    const item = this.queue.find((d) => d.name === trackName);
    if (item) {
      item.events.push(eventPayload);
    } else {
      this.queue.push({
        name: trackName,
        trackFunction,
        events: [eventPayload],
      });
    }
    this.intervalComsume();
  };

  /**
   * 消费埋点存储队列中的数据
   * @param {string} type 需要消费的消息类型
   *
   */
  consume = (type) => {
    this.queue.forEach((item) => {
      try {
        if (type && item.name !== type) return;
        let i = 0;
        const eventCount = item.events.length;
        while (i < eventCount) {
          i++;
          const payload = item.events.shift();
          item.trackFunction.call(item._this ?? this, ...(payload ?? []));
        }
      } catch (e) {
        armsErrorSend(e, { filename: `BI-consumeTrackerQueue ${item.name}` });
      }
    });
  };

  /**
   * 根据类别消费
   * @param {} type 埋点平台类型 tiktok a8Tag等。
   */
  consumeByType = (type) => {
    try {
      const item = this.queue.find((d) => d.name === type);
      let i = 0;
      const eventCount = item.events.length;
      while (i < eventCount) {
        i++;
        const payload = item.events.shift();
        item.trackFunction.call(item._this ?? this, ...(payload ?? []));
      }
    } catch (e) {
      armsErrorSend(e, { filename: `BI-consumeTrackerQueueByType ${type}` });
    }
  };
}

const TrackerQueue = new _TrackerQueue();

// 挂载InstaTrackerQueue到window, 在合适的时机执行
if (typeof window !== 'undefined') {
  window.InstaTrackerQueue = TrackerQueue;
}

export default TrackerQueue;
